import React from 'react';
import cx from 'classnames';

import { Row, Col, Accordion } from 'react-bootstrap';

import styles from './styles.module.scss';
import AssetShareView from '../contactAssetShare';
import Text from 'src/components/text';

import _ from 'lodash';

class SectionShareView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewMore: false
    }

    this.handleSectionClicked = this.handleSectionClicked.bind(this);
  }

  handleSectionClicked() {
    if (this.props.section.fetched) {
      return;
    }

    this.props.fetchShareSection(this.props.conversation.id, this.props.section.id).then(() => {
      this.setState({
        loadAnalytics: true
      })
    });
  }

  render() {
    if (!this.props.section) {
      return null;
    }

    const timeSpent = this.props.section.totalTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    var sectionHeader = (
      <div className={styles.section} onClick={() => {
        this.setState({ viewMore: !this.state.viewMore })
      }}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionMetaData}>
            <button
              className={styles.plusButton}
            >
              <div className={styles.plusIconDiv}>
                {this.state.viewMore ? (
                  <i className="paperflite-minus" aria-hidden="true" />
                ) : (
                  <i className="paperflite-add" aria-hidden="true" />
                )}
              </div>
            </button>

            <div>
              <div className={styles.name}>
                <Text lines={1} text={this.props.section.name} />
              </div>
              <div className={styles.assetCount}>{`${this.props.section.assetsCount || 0} Assets`}</div>
            </div>
          </div>
        </div>
        <div className={styles.metricsContainer}>
          <div className={styles.metrics}>
            <i className="paperflite-eye"></i>
            <p>{this.props.section.assetViewedCount || 0}</p>
          </div>
        </div>
      </div>
    );

    return (
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header onClick={this.handleSectionClicked}>
            <Row className={styles.headerContainer}>
              {sectionHeader}
            </Row>
          </Accordion.Header>
          <Accordion.Body>
            <div className={styles.accordionBodyWrapper}>{this.renderAssets()}</div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }

  renderAssets() {
    if (this.props.section.loading) {
      return <div className={styles.loading}>Loading assets...</div>
    }
    var assets = (this.props.section.assets || []).filter(asset => asset.type === 'ASSET');

    assets = assets.map((asset) => {
      return (
        <AssetShareView className={styles.asset}
          key={asset.id}
          shareId={this.props.shareId}
          contactId={this.props.contactId}
          sectionId={this.props.section.id}
          asset={asset}
          events={asset.events}
          shouldFetchAnalytics={true}
          renderWithin={'conversation'}
          fetchAssetAnalytics={this.props.fetchAssetAnalytics}
          fetchPreviewAsset={this.props.fetchPreviewAsset}
        />
      );
    });

    return assets;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }

    return padding + number;
  }
}

export default SectionShareView;